import React from 'react';

/** Magic UI inspired Marquee with edge fade mask. */
export default function Marquee({
  children,
  className = '',
  pauseOnHover = false,
  reverse = false,
  speed = 60,
  fade = true,
}) {
  const items = React.Children.toArray(children);
  // Marquee duplicates the content twice to create the seamless loop. The
  // index tags differentiate the two copies so React still has stable keys
  // across re-renders even though the same children appear twice.
  const duplicated = [
    ...items.map((c, i) => ({ c, k: `a-${c?.key ?? i}` })),
    ...items.map((c, i) => ({ c, k: `b-${c?.key ?? i}` })),
  ];
  const direction = reverse ? 'reverse' : 'normal';
  return (
    <div
      className={`relative overflow-hidden ${className}`}
      style={fade ? {
        WebkitMaskImage: 'linear-gradient(90deg, transparent 0%, #000 8%, #000 92%, transparent 100%)',
        maskImage: 'linear-gradient(90deg, transparent 0%, #000 8%, #000 92%, transparent 100%)',
      } : undefined}
    >
      <div
        className={`marquee-track-mui ${pauseOnHover ? 'pause-on-hover' : ''}`}
        style={{
          animationDuration: `${speed}s`,
          animationDirection: direction,
        }}
      >
        {duplicated.map(({ c, k }) => (
          <span key={k} className="shrink-0 inline-flex items-center">{c}</span>
        ))}
      </div>
    </div>
  );
}
